/*global google*/
import axios from "axios"
import React, { useEffect, useState } from "react"

const Test = (props) => {
	const [latlng, setLatlng] = useState({
		latitude: 0,
		longitude: 0,
	})

	useEffect(() => {
		navigator.geolocation.getCurrentPosition((position) => {
			setLatlng({
				latitude: position.coords.latitude,
				longitude: position.coords.longitude,
			})
		})
	}, [])

	useEffect(() => {
		axios
			.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=23.9135517,90.3712033&key=AIzaSyCF86ydjbpe01AUAqhdeHS6XeD5Vuj931E`)
			.then((res) => {
				console.log(res)
			})
			.catch((err) => {
				console.log(err)
			})
	}, [])

	// const geocoder =  window.google();

	// geocoder.geocode({ location: latlng })
	//  .then((response) => {
	//   console.log(response)
	// })
	// .catch((err)=>{
	//   console.log(err)
	// })

	console.log(latlng)
	return <div></div>
}

export default Test
